"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import type { BaseProviderFormProps } from "@/components/settings/data-providers/provider-forms/base-provider-form";
import { FormPasswordInput } from "@/components/ui/password-input";
import { ProviderType } from "@/types/dataProvider";
export const RentEngineProviderForm = t0 => {
  const $ = _c(3);
  const {
    form,
    isCreating
  } = t0;
  let t1;
  if ($[0] !== form || $[1] !== isCreating) {
    t1 = <FormPasswordInput autoComplete="new-password" disabled={isCreating} form={form} label="API Key" name="data.credentials.apiKey" placeholder="Enter API Key" type="password" />;
    $[0] = form;
    $[1] = isCreating;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
(RentEngineProviderForm as {
  providerType?: string;
}).providerType = ProviderType.RENTENGINE;